import { ContactForm } from "./ContactForm";

const ICONS = {
  phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z" />,
  mail: <><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" /></>,
  pin: <><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></>,
};

const Ico = ({ bg, name }) => (
  <span className="ico" style={{ background: bg }}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{ICONS[name]}</svg>
  </span>
);

const SOCIAL = [
  { label: "Facebook", href: "https://www.facebook.com/DavisInfiniteCare", svg: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M14 8h3V4h-3c-2.8 0-4.5 1.8-4.5 4.6V11H7v4h2.5v9h4v-9h3l.5-4h-3.5V9c0-.6.4-1 1-1z" /></svg> },
  { label: "Instagram", href: "https://www.instagram.com/DavisInfiniteCare", svg: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r=".6" fill="currentColor" /></svg> },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/DavisInfiniteCare", svg: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.5h4V21H3zM9.5 9.5h3.8v1.6h.1c.5-1 1.8-2 3.8-2 4 0 4.8 2.6 4.8 6V21h-4v-5.1c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V21h-4z" /></svg> },
];

export const Contact = () => (
  <section className="sec" id="contact" data-testid="contact-section">
    <div className="wrap contact-grid">
      <div>
        <div className="head">
          <h2>Contact us</h2>
          <p>Looking for support, want to volunteer, or interested in partnering with us? We'd love to hear from you.</p>
        </div>
        <ul className="ways">
          <li>
            <Ico bg="#5A2D9C" name="phone" />
            <div><b>Call</b><a href="tel:+19547369078" data-testid="contact-phone-1">954-736-9078</a><br /><a href="tel:+18437989979" data-testid="contact-phone-2">843-798-9979</a></div>
          </li>
          <li>
            <Ico bg="#D99A00" name="mail" />
            <div><b>Email</b><a href="mailto:jeanine@davisinfinitecarecorp.com" data-testid="contact-email-link">Jeanine@davisinfinitecarecorp.com</a></div>
          </li>
          <li>
            <Ico bg="#7B3FE4" name="pin" />
            <div><b>Serving</b><span style={{ fontWeight: 800, fontSize: "1.1rem" }}>Lauderhill &amp; Broward County, Florida</span></div>
          </li>
        </ul>
        <p style={{ fontWeight: 700, margin: "0 0 .7rem" }}>Follow @DavisInfiniteCare</p>
        <div className="social">
          {SOCIAL.map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} data-testid={`social-${s.label.toLowerCase()}`}>{s.svg}</a>
          ))}
        </div>
      </div>
      <ContactForm />
    </div>
  </section>
);
